export enum ECommentEntityName {
  client = 'client',
  order = 'order',
  cargo = 'cargo',
  trip = 'trip',
  invoice = 'invoice',
  warehouseTask = 'warehouseTask',
  expenses = 'expenses',
}
